import request from "axios";

export const apiErrorHandler = (error: unknown): string => {
  if (!request.isAxiosError(error)) {
    throw error;
  }

  const { response } = error;

  if (response) {
    return handleError(response.status, response?.data.message);
  }

  return "";
};

const handleError = (status: number, statusText: string): string =>
  `${status} ${statusText}`;
